module.exports = __webpack_public_path__ + "img/logo.242486f7.jpg";